import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const dragAndDropListFn = /* @__PURE__ */ createRecipe('DragAndDropList', {
  "elevation": "default"
}, [])

const dragAndDropListVariantMap = {
  "elevation": [
    "default",
    "none"
  ]
}

const dragAndDropListVariantKeys = Object.keys(dragAndDropListVariantMap)

export const dragAndDropList = /* @__PURE__ */ Object.assign(memo(dragAndDropListFn.recipeFn), {
  __recipe__: true,
  __name__: 'dragAndDropList',
  __getCompoundVariantCss__: dragAndDropListFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: dragAndDropListVariantKeys,
  variantMap: dragAndDropListVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, dragAndDropListVariantKeys)
  },
  getVariantProps: dragAndDropListFn.getVariantProps,
})